const API_ROUTES = {
	loginMagicLink: '/login/magiclink',
	loginMagicLinkSession: '/login/magiclink/session',
	loginMagicLinkVerify: '/login/magiclink/verify',
	loginOAuthStart: '/login/oauth/start',
	loginOAuthExchange: '/login/oauth/exchange',
	loginSSOStart: '/login/saml/start',
	loginSSOExchange: '/login/saml/exchange',
	logout: '/logout',
	loginWebAuthnStart: '/login/webauthn/start',
	loginWebAuthnFinish: '/login/webauthn/finish',
	webAuthn: {
		addStart: '/webauthn/add/start',
		addFinish: '/webauthn/add/finish'
	},
	supportSessionToken: '/support/session/token',
	sdkConfig: '/sdk/config',
	v1: {
		me: '/v1/me',
		wizard: {
			update: '/v1/wizard',
			apply: '/v1/wizard/apply',
			startOver: (id: string) => `/v1/wizard/${id}`
		},
		providers: {
			data: '/v1/settings/providers',
			defaults: '/v1/settings/providers/defaults'
		},
		messaging: {
			service: '/v1/settings/providers/tests/messaging',
			adhoc: '/v1/settings/providers/tests/messaging/adhoc'
		},
		authenticationMethods: {
			get: '/v1/settings/methods',
			magicLink: '/v1/settings/methods/magiclink',
			enchantedLink: '/v1/settings/methods/enchantedlink',
			otp: '/v1/settings/methods/otp',
			social: '/v1/settings/methods/oauth',
			saml: '/v1/settings/methods/saml',
			oidc: '/v1/settings/methods/oidc',
			totp: '/v1/settings/methods/totp',
			webauthn: '/v1/settings/methods/webauthn',
			password: '/v1/settings/methods/password'
		},
		analytics: {
			activeUsers: '/v1/analytics/users/count/active',
			newUsers: '/v1/analytics/users/count/new',
			deviceTypeGraph: '/v1/analytics/users/graph/device',
			activeUsersGraph: '/v1/analytics/users/graph/active',
			newUsersGraph: '/v1/analytics/users/graph/new',
			errors: '/v1/analytics/errors'
		},
		projectLimits: '/v1/project/limits',
		project: '/v1/project',
		company: '/v1/company',
		users: '/v1/users',
		editUser: '/v1/users/',
		uploadUsers: '/v1/users/upload',
		inviteUsers: '/v1/users/invite',
		batchDelete: '/v1/users/batch/delete',
		batchSuspend: '/v1/users/batch/suspend',
		batchActivate: '/v1/users/batch/activate',
		batchTenants: '/v1/users/batch/update',
		admins: {
			all: '/v1/admins',
			invite: '/v1/admins/invite',
			delete: '/v1/admins/delete'
		},
		tenants: {
			all: '/v1/tenants',
			settings: {
				saml: (id: string) => ({
					get: `/v1/tenants/${id}/settings/methods/saml`,
					set: `/v1/tenants/${id}/settings/methods/saml`,
					metadata: `/v1/tenants/${id}/settings/methods/saml/metadata`,
					certificate: `/v1/tenants/${id}/settings/methods/saml/certificate`,
					mappings: `/v1/tenants/${id}/settings/methods/saml/mappings`
				})
			}
		},
		flows: {
			all: '/v1/flows',
			download: '/v1/flows/json',
			upload: `v1/flows/import`,
			metadata: '/v1/flows/metadata',
			theme: {
				all: '/v1/flows/theme',
				download: '/v1/flows/theme/json',
				upload: '/v1/flows/theme/import'
			},
			flow: (id: string) => ({
				download: `v1/flows/${id}/json`,
				disable: `/v1/flows/${id}/disable`,
				screens: `/v1/flows/${id}/screens`,
				screenAvailable: `/v1/flows/${id}/screens/available`
			})
		},
		accessKeys: {
			all: '/v1/accesskeys',
			generate: '/v1/accesskeys',
			update: '/v1/accesskeys',
			delete: (id: string) => `/v1/accesskeys/${id}`,
			activate: '/v1/accesskeys/activate',
			deactivate: '/v1/accesskeys/deactivate'
		},
		managementKeys: {
			all: '/v1/managementkeys',
			generate: '/v1/managementkeys',
			update: '/v1/managementkeys',
			delete: (id: string) => `/v1/managementkeys/${id}`,
			activate: '/v1/managementkeys/activate',
			deactivate: '/v1/managementkeys/deactivate'
		},
		permissions: {
			all: '/v1/authorization/permissions',
			add: '/v1/authorization/permissions',
			update: '/v1/authorization/permissions',
			delete: (id: string) => `/v1/authorization/permissions/${id}`
		},
		roles: {
			all: '/v1/authorization/roles',
			add: '/v1/authorization/roles',
			update: '/v1/authorization/roles',
			delete: (id: string) => `/v1/authorization/roles/${id}`
		},
		audits: '/v1/audits'
	}
};

export default API_ROUTES;
